import { useState } from "react";
import { useAccount } from "context/AccountContext";
import { useDialog } from "context/DialogContext";
import Trans from "features/translation/components/Trans";
import Alert from "components/ui/Alert/Alert";
import Loader from "components/ui/Loader/Loader";
import { Link, useHistory } from "react-router-dom";
import "features/authentication/components/LoginForm/LoginForm.scss";
import useData from "hooks/useData";
import ProfileCreateUpdate from "pages/Profile/ProfileCreateUpdate";
import RequestPasswordReset from "features/authentication/components/RequestPasswordReset";
import Button from "components/ui/Button/Button";

const LoginForm = () => {
  const [ email, setEmail ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ error, setError ] = useState();
  const [ isLoggingIn, setIsLoggingIn ] = useState();
  const { setUser, setProfile } = useAccount();
  const { showDialog, hideDialog } = useDialog();
  const { postData } = useData();
  const history = useHistory();
  const [ passwordShown, setPasswordShown ] = useState(false);

  const authenticate = async (email, password) => {
    setError();
    setUser();
    setProfile();
    setIsLoggingIn(true);

    let result;
    result = await postData('rest/stb/login', { 'username': email.trim(), 'password': password });

    switch (result?.status) {
      case 200:
        const user = await result.json();
        setUser(user);
        if (user) {
          setProfile(user.profile);
        }
        if (user && user.profile && user.profile.field_profile_completed.value === '1') {
          hideDialog();
        } else {
          showDialog(<ProfileCreateUpdate/>);
        }

        let destination = window.location.pathname !== '/login' ? window.location.pathname + window.location.search : null;
        if (!destination || destination.substring(0, 1) !== '/') {
          destination = '/startpagina';
        }
        history.push(destination);
        break;

      case 401:
        setError(window.Drupal.t('De combinatie van e-mailadres en wachtwoord is niet juist. Probeer het opnieuw of stel een nieuw wachtwoord in.'));
        break;

      default:
        setError(window.Drupal.t('Er is helaas iets mis gegaan waardoor het op het dit moment niet mogelijk is om in te loggen. Probeer het later opnieuw.'))
    }

    setIsLoggingIn(false);
  }

  const submitForm = (event) => {
    event.preventDefault();

    if (!email) {
      setError('U heeft nog geen e-mailadres opgegeven.')
      return;
    }

    if (!email.trim().match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/i)) {
      setError('Het opgegeven e-mailadres is ongeldig.')
      return;
    }

    if (password.toString() === '') {
      setError('U heeft nog geen wachtwoord opgegeven.')
      return;
    }

    authenticate(email, password);
  }

  const handleForgotPassword = (event) => {
    showDialog(<RequestPasswordReset title={ `Wachtwoord vergeten` }/>);
    event.preventDefault();
  }

  const handleActivateAccount = () => {
    showDialog(<RequestPasswordReset title={ `Account aanmaken` } createAccount={ true }/>);
  }

  if (isLoggingIn) {
    return <Loader containerVariant={ 'center' }/>;
  }

  const toggleShowPassword = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <>
      <div className={ `login-content` }>
        <div className={ `login-content__login` }>
          <h2>{ `Inloggen` }</h2>
          <p>
            <Trans
              text={ `Als ANBO-PCOB-lid kunt u hier inloggen met het e-mailadres dat bij ANBO-PCOB bekend is en het door u aangemaakte wachtwoord.` }/>
          </p>
          { error && <Alert title={ `Inloggen` } message={ error }/> }
          <form onSubmit={ submitForm } className={ `login-form` }>
            <div className={ `login-form__email` }>
              <label htmlFor={ `email` }><Trans text="E-mailadres"/></label>
              <input type={ `text` }
                     name={ `email` }
                     value={email}
                     onChange={event => setEmail(event.target.value)}
                     autoComplete={ `username` }
                     autoFocus/>
            </div>

            <div className={ `login-form__password` }>
              <label htmlFor={ `password` }><Trans text="Wachtwoord"/></label>
              <input type={ passwordShown ? "text" : "password" }
                     name={ `password` }
                     value={ password }
                     onChange={ event => setPassword(event.target.value) }
                     autoComplete={ `current-password` }/>

              <div className={ `login-form__show-password` }>
                <input type={ `checkbox` }
                       id={ `showPassword` }
                       checked={ passwordShown }
                       onChange={ toggleShowPassword }
                       name={ `showPassword` }/>
                <label htmlFor={ `showPassword` } className={ `pointer` }>
                  Toon wachtwoord
                </label>
              </div>
            </div>

            <div>
              <input type={ `submit` }
                     value={ `Inloggen` }
                     className={ `button button--secondary button--full-width` }/>
            </div>
          </form>
        </div>
        <div className={ `login-content__account` }>
          <div>
            <h2>{ `Ik ben nieuw bij Trefpunt` }</h2>
            <p>
              <Trans
                text={ `U bent lid van ANBO-PCOB, maar nog niet eerder op Trefpunt geweest. Maak dan eerst een account voor Trefpunt aan.` }/>
            </p>
          </div>
          <Button onClick={ handleActivateAccount } variant={ 'primary' }>Account aanmaken</Button>
        </div>
        <div className={ `login-form__forgot` }>
          <Link to={ `#` } onClick={ handleForgotPassword }>Wachtwoord vergeten?</Link>
        </div>
      </div>
    </>
  )
}

export default LoginForm;
